import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useNavigation } from 'app/hooks/navigation';
import { getI18nLanguage } from 'app/lib/language';
import { getCountriesByLanguage } from 'app/localization/countries';
import { getCountryProvincesByLanguage } from 'app/localization/provinces';
import type { Address } from 'app/types/address';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

export function AddressCard({ administrativeArea, city, country, id, postalCode, street, unit }: Address) {
  const navigation = useNavigation();
  const { t } = useTranslation('my-neighbourhood');
  const language = getI18nLanguage();

  const provincesInCountry = getCountryProvincesByLanguage(country, language);
  const provinceName = provincesInCountry.find((p) => p.code === administrativeArea)?.name;
  const countryName = getCountriesByLanguage(language).find((c) => c.code === country)?.name;

  return (
    <Pressable onPress={() => navigation.navigate('my-address', { id }, { pop: true })}>
      <Column
        borderColor="text.placeholder"
        borderRadius="radius.lg"
        borderWidth={1}
        gap="spacing.general.x1"
        key={id}
        padding="spacing.general.x4"
      >
        <Row alignItems="flex-start" flex={1} justifyContent="space-between">
          <Column flex={1} gap="spacing.general.x1" marginEnd="spacing.general.x2">
            {[street, unit].filter(Boolean).length > 0 && (
              <Text numberOfLines={1}>{[street, unit].filter(Boolean).join(', ')}</Text>
            )}
            <Text numberOfLines={1}>
              {country === 'BE' || country === 'FR'
                ? [postalCode, city, provinceName].filter(Boolean).join(' ')
                : [city, provinceName, postalCode].filter(Boolean).join(', ')}
            </Text>
          </Column>

          <Text color="text.placeholder">{t('edit')}</Text>
        </Row>
        {countryName ? <Text>{countryName}</Text> : null}
      </Column>
    </Pressable>
  );
}
